module.exports = __webpack_public_path__ + "static/media/embed.b097ae33.svg";